export const GENERAL_ERROR_MESSAGE = 'Something went wrong';

interface ErrorPayload {
    [key: string]: any;
}

interface LogErrorOptions {
    module?: string;
    payload?: ErrorPayload;
}

interface ExtendedError extends Error {
    details?: {
        payload: ErrorPayload;
        package: string;
        module: string;
    };
}

/**
 * Logs the error to the monitoring system.
 * @param err - The error to log
 * @param options - Additional options for logging
 */
export const logError = (err: Error | string | unknown, { module = '', payload = {} }: LogErrorOptions = {}): void => {
    let error: ExtendedError;

    if (err instanceof Error) {
        error = err;
    } else if (typeof err === 'string') {
        error = new Error(err);
    } else {
        error = new Error(GENERAL_ERROR_MESSAGE);
    }

    error.details = {
        payload,
        package: '@fiverr-private/realtime_notifications',
        module,
    };

    setTimeout(() => {
        throw error;
    });
};
